const state = {
  multipleId: '' // src/components/amap/child/coordinate.vue 传值到 src/components/system/control/list.vue
};

export default state;
